import React from 'react';
import { createPortal } from 'react-dom';
import { Coins } from 'lucide-react';
import { getIpeWorkspaceMode } from '@/utils/api';
import { workspaceScopeLabel } from '@/pages/ipe/workbench/utils/accountCenterUtils';

export default function IpeCreditsInsufficientDialog({
  open,
  message,
  onClose,
  onOpenAccountCenter,
  workspaceMode,
}) {
  if (!open) return null;

  const label = workspaceScopeLabel(workspaceMode || getIpeWorkspaceMode());
  const text =
    message ||
    `当前${label}IPE豆余额不足，无法继续执行该操作。请联系商务充值IPE豆，或前往账号中心查看余额与价目。`;

  return createPortal(
    <div className="ipe-account-modal" role="presentation" onClick={onClose}>
      <div
        className="ipe-account-modal__panel ipe-account-modal__panel--compact ipe-credits-dialog__panel"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="ipe-credits-dialog-title"
        onClick={(ev) => ev.stopPropagation()}
      >
        <div className="ipe-credits-dialog__icon" aria-hidden="true">
          <Coins size={28} strokeWidth={1.8} />
        </div>
        <h2 id="ipe-credits-dialog-title" className="ipe-account-modal__title">
          {label}IPE豆不足
        </h2>
        <p className="ipe-account-modal__message">{text}</p>
        <div className="ipe-account-modal__actions">
          <button type="button" className="ipe-account-modal__btn ipe-account-modal__btn--ghost" onClick={onClose}>
            我知道了
          </button>
          {onOpenAccountCenter ? (
            <button
              type="button"
              className="ipe-account-modal__btn ipe-account-modal__btn--primary"
              onClick={() => {
                onOpenAccountCenter();
                onClose();
              }}
            >
              前往账号中心
            </button>
          ) : null}
        </div>
      </div>
    </div>,
    document.body,
  );
}
